import * as React from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import {
  CssDataJacketTitleTypography,
  CssDataJacketBodyTypography,
  CssDataJacketButton,
  CssDataJacketMiniButton,
  CssBtnTypography,
  CssDataJacketBodyChip,
} from "../../styles/styled";
import { grey } from "@mui/material/colors";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Unstable_Grid2";
import UpdateIcon from "@mui/icons-material/Update";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import CustomBreadcrumbMenu from "../other/breadcrumb";
import HubIcon from "@mui/icons-material/Hub";
import Slide from "@mui/material/Slide";
import Fade from "@mui/material/Fade";
import { getDataJacketImage, favoriteChange } from "../../js/queriesHandling";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Button from "@mui/material/Button";

const customTheme = createTheme({
  palette: {
    primary: {
      main: "#303234",
      sub: grey[50],
      light: grey[50],
      dark: grey[900],
      constrastText: grey[50],
    },
    secondary: {
      main: grey[900],
    },
  },
});

const Item = styled(Paper)(({ theme }) => ({
  textAlign: "center",
  backgroundColor: "#303234",
  boxShadow: "none",
}));

const DataJacketItem = styled(Item)`
  ${({ theme }) => `
  text-align: 'left';
  `}
`;

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "black",
    maxWidth: 220,
  },
}));

const CssBox = styled(Box)({
  paddingLeft: "52px",
  maxWidth: "1300px",
  zIndex: "4",
  display: "flex",
});

const menu = [
  { title: "データジャケット一覧", link: "/datalist" },
  { title: "データジャケット詳細", link: "" },
];

export default function DataJacketTabSummary({
  dataJacket,
  networkMode,
  networkNavigate,
  setScroll,
  scroll,
  user,
  setfavoriteFlag,
}) {
  const [image, setImage] = React.useState("");
  const topRef = React.useRef();

  async function getImage(id) {
    var strImage = await getDataJacketImage(id);
    setImage({ data: strImage.replace(/\"/g, "") });
  }

  const sendfavoriteInformation = () => {
    favoriteChange(
      user,
      dataJacket.data_jacket_id,
      dataJacket.user_favorite_flag
    )
      .then((evt) => {
        setfavoriteFlag(evt);
      })
      .catch((err) => {});
  };

  React.useEffect(() => {
    getImage(dataJacket.data_jacket_id);
    const observer = new IntersectionObserver((entries, observer) => {
      const entry = entries[0];
      setScroll(!entry.isIntersecting);
    });
    observer.observe(topRef.current);
  }, [dataJacket]);

  function industryChip() {
    let result = [];
    let tooltip = [];
    try {
      dataJacket.data_jacket_industry.split(",").map((industry, index) => {
        if (industry !== "" && industry !== undefined) {
          if (index < 6) {
            result.push(
              <CssDataJacketBodyChip
                style={{
                  marginTop: "0",
                  marginRight: "0",
                  padding: "-4px -4px -4px -4px",
                  backgroundColor: "#75787B",
                }}
                label={industry}
              />
            );
          } else {
            tooltip.push(
              <CssDataJacketBodyTypography style={{ color: "black" }}>
                {industry}
              </CssDataJacketBodyTypography>
            );
          }
        }
      });
      if (tooltip.length > 0) {
        result.push(
          <HtmlTooltip title={tooltip}>
            <CssDataJacketBodyChip
              style={{
                marginTop: "0",
                marginRight: "0",
                padding: "-4px -4px -4px -4px",
                backgroundColor: "#75787B",
              }}
              label={"..."}
            />
          </HtmlTooltip>
        );
      }
      return result;
    } catch (e) {}
  }

  React.useEffect(() => {
    getImage(dataJacket.data_jacket_id);
    const observer = new IntersectionObserver((entries, observer) => {
      const entry = entries[0];
      setScroll(!entry.isIntersecting);
    });
    observer.observe(topRef.current);
  }, [dataJacket]);

  return (
    <>
      <Box ref={topRef} id="TopDetail">
        <Box
          sx={{
            position: "relative",
            display: "inherit",
            height: "210px",
          }}
        >
          {image.data ? (
            <Fade in={true} timeout={800}>
              <img
                src={`data:image/png;base64,${image.data}`}
                alt={"データジャケット画像"}
                style={{
                  height: "200px",
                  width: "100%",
                  objectFit: "cover",
                }}
              />
            </Fade>
          ) : (
            ""
          )}
        </Box>
        <Box
          style={{
            marginLeft: "52px",
          }}
        >
          <CustomBreadcrumbMenu menu={menu} />
        </Box>
        <Fade in={true} timeout={500}>
          <CssBox style={{ marginRight: "32px", width: "75%" }}>
            <ThemeProvider theme={customTheme}>
              <Grid container spacing={0.5} columns={24}>
                <Grid container xs={24} columns={24}>
                  <Grid xs={12}>
                    <DataJacketItem
                      style={{
                        textAlign: "left",
                        backgroundColor: "#303234",
                        boxShadow: "none",
                      }}
                    >
                      <CssDataJacketTitleTypography
                        style={{
                          marginLeft: "0",
                          fontWeight: "bold",
                          fontSize: "32px",
                        }}
                      >
                        {dataJacket.data_jacket_name}
                      </CssDataJacketTitleTypography>
                    </DataJacketItem>
                  </Grid>
                  <Grid xs={2}></Grid>
                  <Grid xs={5}>
                    <DataJacketItem
                      style={{
                        padding: "0",
                        display: "flex",
                        justifyContent: "right",
                        marginTop: "12px",
                      }}
                    >
                      <CssDataJacketButton
                        style={{
                          width: networkMode === "redirect" ? "240px" : "220px",
                          whiteSpace: "nowrap",
                          minWidth: "220px",
                        }}
                        onClick={networkNavigate}
                      >
                        <HubIcon style={{ color: "white" }} />　
                        {networkMode === "redirect"
                          ? "ネットワーク図へ戻る"
                          : "ネットワーク図表示"}
                      </CssDataJacketButton>
                    </DataJacketItem>
                  </Grid>
                  <Grid xs={5}>
                    <DataJacketItem
                      style={{
                        padding: "0",
                        display: "flex",
                        justifyContent: "right",
                        marginTop: "12px",
                        marginLeft: "220px",
                      }}
                    >
                      {dataJacket.user_favorite_flag === false ? (
                        <CssDataJacketButton
                          style={{
                            width:
                              networkMode === "redirect" ? "240px" : "220px",
                            whiteSpace: "nowrap",
                            minWidth: "220px",
                          }}
                          onClick={sendfavoriteInformation}
                        >
                          <FavoriteBorderIcon style={{ color: "white" }} />
                          {"お気に入り登録"}
                        </CssDataJacketButton>
                      ) : (
                        <Button
                          style={{
                            width:
                              networkMode === "redirect" ? "240px" : "220px",
                            backgroundColor: "grey",
                            color: "white",
                            height: "40px",
                            border: "2px solid white",
                            fontWeight: "bold",
                            fontSize: "16px",
                            whiteSpace: "nowrap",
                            minWidth: "220px",
                          }}
                          onClick={sendfavoriteInformation}
                        >
                          <FavoriteIcon style={{ color: "white" }} />
                          {"お気に入り登録解除"}
                        </Button>
                      )}
                    </DataJacketItem>
                  </Grid>
                </Grid>
                <Grid container columns={24}>
                  <Grid xs={24}>
                    <DataJacketItem
                      style={{
                        padding: "0",
                        display: "flex",
                        textAlign: "left",
                      }}
                    >
                      <CssDataJacketBodyTypography
                        style={{
                          marginLeft: "0",
                          fontSize: "16px",
                        }}
                      >
                        {dataJacket.data_jacket_summary}
                      </CssDataJacketBodyTypography>
                    </DataJacketItem>
                  </Grid>
                </Grid>
                <Grid container xs={24} columns={24}>
                  <Grid xs={12}>
                    <DataJacketItem
                      style={{
                        padding: "0",
                        color: "white",
                        display: "flex",
                      }}
                    >
                      <LocalOfferIcon
                        style={{
                          marginTop: "6px",
                          color: "white",
                          marginRight: "8px",
                        }}
                      />
                      <Box
                        style={{
                          textAlign: "left",
                          fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                        }}
                      >
                        {industryChip()}
                      </Box>
                    </DataJacketItem>
                  </Grid>
                  <Grid xs={12}>
                    <DataJacketItem
                      style={{
                        padding: "0",
                        color: "white",
                        display: "flex",
                        justifyContent: "right",
                      }}
                    >
                      <UpdateIcon
                        style={{ color: "white", marginRight: "8px" }}
                      />
                      <Box>
                        {String("発行日：").concat(
                          String(dataJacket.data_jacket_date_published)
                            .substring(0, 10)
                            .replace(/-/g, "/"),
                          "　最終更新日：",
                          String(dataJacket.data_jacket_date_update)
                            .substring(0, 10)
                            .replace(/-/g, "/")
                        )}
                      </Box>
                    </DataJacketItem>
                  </Grid>
                </Grid>
              </Grid>
            </ThemeProvider>
          </CssBox>
        </Fade>
      </Box>
      {scroll && (
        <Slide
          direction="down"
          timeout={800}
          in={true}
          mountOnEnter
          unmountOnExit
        >
          <Box
            style={{
              transform: "translateY(0px)",
              width: "100%",
              height: "80px",
              position: "sticky",
              top: "75px",
              left: "0",
              zIndex: "4",
              display: "flex",
              backgroundColor: "#303234",
              justifyContent: "left",
            }}
          >
            <Stack
              spacing={{ xs: 2, sm: 1 }}
              style={{ marginLeft: "52px", marginTop: "8px" }}
              direction="column"
              flexWrap="wrap"
            >
              <CustomBreadcrumbMenu menu={menu} />
              <Stack spacing={{ xs: 2, sm: 1 }} direction="row" flexWrap="wrap">
                <Item>
                  <CssBtnTypography
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    {dataJacket.data_jacket_name}
                  </CssBtnTypography>
                </Item>
                <Item>
                  <CssDataJacketMiniButton onClick={networkNavigate}>
                    <HubIcon style={{ color: "white" }} />
                  </CssDataJacketMiniButton>
                </Item>
                <Item>
                  {dataJacket.user_favorite_flag === false ? (
                    <CssDataJacketMiniButton onClick={sendfavoriteInformation}>
                      <FavoriteBorderIcon style={{ color: "white" }} />
                    </CssDataJacketMiniButton>
                  ) : (
                    <CssDataJacketMiniButton
                      onClick={sendfavoriteInformation}
                      style={{ backgroundColor: "grey" }}
                    >
                      <FavoriteIcon style={{ color: "white" }} />
                    </CssDataJacketMiniButton>
                  )}
                </Item>
              </Stack>
            </Stack>
          </Box>
        </Slide>
      )}
    </>
  );
}
